
///////////////////////////////////////////////////////
// import { useState } from "react";
// import { Routes, Route ,Navigate} from "react-router-dom";
// import Topbar from "./scenes/global/Topbar";
// import Sidebar from "./scenes/global/Sidebar";
// import Dashboard from "./scenes/dashboard";
// import Team from "./scenes/team"; 
// import { CssBaseline, ThemeProvider } from "@mui/material";
// import { ColorModeContext, useMode } from "./theme";
// import Calendar from "./scenes/calendar/calendar";
// import LeaveSection from "./scenes/Leaves"
// import ApplyLeave from "./scenes/ApplyLeave";
// import AppliedLeaves from "./scenes/AppliedLeaves";
// import PublicHolidays from "./scenes/PublicHolidays";
// import Login from "./login";
// import { signInwithGoogle } from "./firebase";
// import ApproveLeave from "./scenes/ApproveLeave";

// function App() {
//   const [theme, colorMode] = useMode();
//   const [isSidebar, setIsSidebar] = useState(true);
//   const [isLoggedIn, setIsLoggedIn] = useState(false); // new state to track login status

//   // Function to set isLoggedIn state to true on successful login
//   const handleLogin = () => {
//     setIsLoggedIn(true);
//   }

//   // Function to handle login form submission
//   const handleLoginFormSubmit = (email, password) => {
//     // Call the signInwithGoogle function to sign in with Google
//     signInwithGoogle(email, password)
//       .then(() => {
//         // If the sign-in is successful, call the handleLogin function to set isLoggedIn state to true
//         handleLogin();
//       })
//       .catch((error) => {
//         alert(error.message); // Show an error message if the sign-in is unsuccessful
//       });
//   };

//   // If not logged in, render the Login component
//   if (!isLoggedIn) {
//     return <Login handleLoginFormSubmit={handleLoginFormSubmit} />;
//   } else {
//     // If logged in, render the app content
//     return (
//       <ColorModeContext.Provider value={colorMode}>
//         <ThemeProvider theme={theme}>
//           <CssBaseline />
//           <div className="app">
//             <Sidebar isSidebar={isSidebar} />
//             <main className="content">
//               <Topbar setIsSidebar={setIsSidebar} />
//               <Routes>
//                 <Route path="/Dashboard" element={<Dashboard />} />
//                 <Route path="/team" element={<Team />} />
//                 <Route path="/calendar" element={<Calendar />} />
//                 <Route path="/LeaveSection" element={<LeaveSection/>}/>
//                 <Route path="/ApplyLeave" element={<ApplyLeave/>}/>
//                 <Route path="/AppliedLeaves" element={<AppliedLeaves/>}/>
//                 <Route path="/PublicHolidays" element={<PublicHolidays/>}/>
//                 <Route path="/ApproveLeave" element={<ApproveLeave/>}/>
//                 <Route path="*" element={<Navigate to="/Dashboard" />} />
//               </Routes>
//             </main>
//           </div>
//         </ThemeProvider>
//       </ColorModeContext.Provider>
//     );
//   }
// }

// export default App;
////////////////////////////////////////////



//our previous UI  route that we have to change that causing an issuee that access denied 


// 


//our previous UI  route that we have to change that causing an issuee that access denied 


// import { useState, useEffect } from "react";
// // import { Routes, Route, Navigate } from "react-router-dom";
// // import Topbar from "./scenes/global/Topbar";
// // import Sidebar from "./scenes/global/Sidebar";
// // import Dashboard from "./scenes/dashboard";
// // import Team from "./scenes/team";
// // import { CssBaseline, ThemeProvider } from "@mui/material";
// // import { ColorModeContext, useMode } from "./theme";
// // import Calendar from "./scenes/calendar/calendar";
// // import LeaveSection from "./scenes/Leaves"
// // import ApplyLeave from "./scenes/ApplyLeave";
// // import AppliedLeaves from "./scenes/AppliedLeaves";
// // import PublicHolidays from "./scenes/PublicHolidays";
// // import Login from "./login";
// // import { signInwithGoogle } from "./firebase";
// // import ApproveLeave from "./scenes/ApproveLeave";
// // import { Box, } from '@mui/material';
// // import Header from "./components/Header";
// // import Past90DaysData from "./scenes/dashboard/past90days";
// // import TranssitionHistory from "./scenes/dashboard/transsitionhistory"
// // import CurrentMonthData from "./scenes/dashboard/currentmonth";
// // import CheckInOutRecords from "./scenes/Attendence/CheckInCheckOut";
// // import AppPersonalDetails from "./hrm/app/views/material-kit/HRAdmin/AppPersonalDetails";
// // import AddEmployee from "./hrm/app/views/material-kit/HRAdmin/AddEmployee";
// // import AddJob from "./hrm/app/views/material-kit/HRAdmin/AddJob";

// import AppAddressDetails from "./hrm/app/views/material-kit/HRAddress/AppAddressDetails";
// import AppBankDetails from "./hrm/app/views/material-kit/HRAddress/AppBankDetails";
// import AppDocument from "./hrm/app/views/material-kit/HRDocument/AppDocument";
// import AppQualification from "./hrm/app/views/material-kit/HRQualification/AppQualificationDetails";
// import AppEmployeeWorkExperience from "./hrm/app/views/material-kit/HRWorkExperience/AppWorkExperience";
// import AppEmergencyContact from "./hrm/app/views/material-kit/HREmergencyContact/AppEmergencyContact";
// import AppAutoComplete from "./hrm/app/views/material-kit/auto-complete/AppAutoComplete";
// import Holiday from "./hrm/app/views/material-kit/holidays/Holidays";
// import CheckInOut from "./hrm/app/views/material-kit/holidays/CheckInOut";
// import CsvUploader from "./hrm/app/views/material-kit/CSV/CsvUploader";
// import Analytics from "./hrm/app/views/dashboard/Analytics";
// import { jwtDecode } from "jwt-decode";
// import AppEmpList from "./hrm/app/views/material-kit/HRAdmin/AppEmpList";
// import EmployeeDetails from "./hrm/app/views/material-kit/HRAdmin/EmployeeDetails";
// import EditEmployee from "./hrm/app/views/material-kit/HRAdmin/EditEmployee";
// import AppAddressDetails from "./hrm/app/views/material-kit/HRAddress/AppAddressDetails";
// import AppBankDetails from "./hrm/app/views/material-kit/HRAddress/AppBankDetails";
// import AppDocument from "./hrm/app/views/material-kit/HRDocument/AppDocument";
// import AppQualification from "./hrm/app/views/material-kit/HRQualification/AppQualificationDetails";
// import AppEmployeeWorkExperience from "./hrm/app/views/material-kit/HRWorkExperience/AppWorkExperience";
// import AppEmergencyContact from "./hrm/app/views/material-kit/HREmergencyContact/AppEmergencyContact";
// import AppAutoComplete from "./hrm/app/views/material-kit/auto-complete/AppAutoComplete";
// import Holiday from "./hrm/app/views/material-kit/holidays/Holidays";
// import CheckInOut from "./hrm/app/views/material-kit/holidays/CheckInOut";
// import CsvUploader from "./hrm/app/views/material-kit/CSV/CsvUploader";
// import Analytics from "./hrm/app/views/dashboard/Analytics";
// import { jwtDecode } from "jwt-decode";
// import AppEmpList from "./hrm/app/views/material-kit/HRAdmin/AppEmpList";
// import EmployeeDetails from "./hrm/app/views/material-kit/HRAdmin/EmployeeDetails";
// import EditEmployee from "./hrm/app/views/material-kit/HRAdmin/EditEmployee";

// import EditAddress from "./hrm/app/views/material-kit/HRAddress/EditAddress";
// import EditDocument from "./hrm/app/views/material-kit/HRDocument/EditDocument";
// import EditPersonal from "./hrm/app/views/material-kit/HRAdmin/EditPersonal";
// import EditWork from "./hrm/app/views/material-kit/HRWorkExperience/EditWork";
// import EditQualification from "./hrm/app/views/material-kit/HRQualification/EditQualification";
// import EditEmergency from "./hrm/app/views/material-kit/HREmergencyContact/EditEmergency";
// import PayrollTable from "./scenes/payroll/PayrollTable";
// import EmployeePayroll from "./scenes/payroll/EmployeePayroll";
// import CTCForm from "./scenes/payroll/CTCForm";
// import PayrollPage from "./scenes/payroll/PayrollPage";
// import Payslip from "./scenes/payroll/Payslip";
// import Jobapplication from "./hrm/app/views/material-kit/jobapplication";
// import JobDetails from "./hrm/app/views/material-kit/jobapplication/jobdetails";
// import LeaveDetails from "./scenes/ApproveLeave/Leavedetails";
// import AddExistingEmployeePayroll from "./scenes/payroll/AddExistingEmployeePayroll";


// function App() {
//   const [theme, colorMode] = useMode();
//   const [isSidebar, setIsSidebar] = useState(true);
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   const [accessLevel, setAccessLevel] = useState("employee");
//   const [isLoading, setIsLoading] = useState(true);
// import EditAddress from "./hrm/app/views/material-kit/HRAddress/EditAddress";
// import EditDocument from "./hrm/app/views/material-kit/HRDocument/EditDocument";
// import EditPersonal from "./hrm/app/views/material-kit/HRAdmin/EditPersonal";
// import EditWork from "./hrm/app/views/material-kit/HRWorkExperience/EditWork";
// import EditQualification from "./hrm/app/views/material-kit/HRQualification/EditQualification";
// import EditEmergency from "./hrm/app/views/material-kit/HREmergencyContact/EditEmergency";
// import PayrollTable from "./scenes/payroll/PayrollTable";
// import EmployeePayroll from "./scenes/payroll/EmployeePayroll";
// import CTCForm from "./scenes/payroll/CTCForm";
// import PayrollPage from "./scenes/payroll/PayrollPage";
// import Payslip from "./scenes/payroll/Payslip";
// import Jobapplication from "./hrm/app/views/material-kit/jobapplication";
// import JobDetails from "./hrm/app/views/material-kit/jobapplication/jobdetails";
// import LeaveDetails from "./scenes/ApproveLeave/Leavedetails";
// import AddExistingEmployeePayroll from "./scenes/payroll/AddExistingEmployeePayroll";


// function App() {
//   const [theme, colorMode] = useMode();
//   const [isSidebar, setIsSidebar] = useState(true);
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   const [accessLevel, setAccessLevel] = useState("employee");
//   const [isLoading, setIsLoading] = useState(true);

//   const [acess,setaccess]=useState("");
//   const [acess,setaccess]=useState("");

  


//   useEffect(() => {
//     // Check if the user is already logged in using sessionStorage
//     const loggedIn = sessionStorage.getItem("loggedIn");
//     if (loggedIn === "true") {
//       setIsLoggedIn(true);
//       // Set the access level based on the stored value in localStorage
//       const storedAccessLevel = localStorage.getItem("AccessLevel");
//       setAccessLevel(storedAccessLevel || "employee");
//     }
//   useEffect(() => {
//     // Check if the user is already logged in using sessionStorage
//     const loggedIn = sessionStorage.getItem("loggedIn");
//     if (loggedIn === "true") {
//       setIsLoggedIn(true);
//       // Set the access level based on the stored value in localStorage
//       const storedAccessLevel = localStorage.getItem("AccessLevel");
//       setAccessLevel(storedAccessLevel || "employee");
//     }

//     getUserFromToken()
//   }, []);
//     getUserFromToken()
//   }, []);


    




//   function getUserFromToken() {
//     const token = sessionStorage.getItem("authToken");
//   function getUserFromToken() {
//     const token = sessionStorage.getItem("authToken");
  
//     if (!token) {
//       console.error("No token found. User is not authenticated.");
//       setIsLoading(false);
//       return null;
//     }
//     if (!token) {
//       console.error("No token found. User is not authenticated.");
//       setIsLoading(false);
//       return null;
//     }
  
//     try {
//       const decoded = jwtDecode(token); // Decode JWT
//       console.log("i am in the app ")
//       console.log("Decoded Token:", decoded);
//     try {
//       const decoded = jwtDecode(token); // Decode JWT
//       console.log("i am in the app ")
//       console.log("Decoded Token:", decoded);


//       if (decoded.isAdmin) {
//         setaccess("admin");
//       } else {
//         setaccess("employee");
//       }
//       if (decoded.isAdmin) {
//         setaccess("admin");
//       } else {
//         setaccess("employee");
//       }
  
//       console.log(acess);
//       setIsLoading(false);
//       console.log(acess);
//       setIsLoading(false);
  
//       return decoded; 
//       // { email, isAdmin, exp }
//     } catch (error) {
//       console.error("Invalid token:", error);
//       setIsLoading(false);
//       return null;
//     }
//   }
//       return decoded; 
//       // { email, isAdmin, exp }
//     } catch (error) {
//       console.error("Invalid token:", error);
//       setIsLoading(false);
//       return null;
//     }
//   }






//   const handleLogin = (userInfo, useralldetails) => {
//     // Store user information in localStorage
//     localStorage.setItem("userInfo", JSON.stringify(userInfo));
//     localStorage.setItem("useralldetails", useralldetails);
//     // Set the isLoggedIn state to true
//     setIsLoggedIn(true);
//     // Set the loggedIn flag in sessionStorage
//     sessionStorage.setItem("loggedIn", "true");
//     // Set the access level based on the stored value in localStorage
//     const storedAccessLevel = localStorage.getItem("AccessLevel");
//     setAccessLevel(storedAccessLevel || "employee");
//   }
//   const handleLogout = () => {
//     // Set the isLoggedIn state to false
//     setIsLoggedIn(false);
//     // Remove the loggedIn flag from sessionStorage
//     sessionStorage.removeItem("loggedIn");
//     // Remove the access level from localStorage
//     localStorage.removeItem("AccessLevel");
//   }
//   const handleLoginFormSubmit = (email, password) => {
//     signInwithGoogle(email, password)
//       .then((user) => {
//         // Pass in the user information to handleLogin
//   const handleLogin = (userInfo, useralldetails) => {
//     // Store user information in localStorage
//     localStorage.setItem("userInfo", JSON.stringify(userInfo));
//     localStorage.setItem("useralldetails", useralldetails);
//     // Set the isLoggedIn state to true
//     setIsLoggedIn(true);
//     // Set the loggedIn flag in sessionStorage
//     sessionStorage.setItem("loggedIn", "true");
//     // Set the access level based on the stored value in localStorage
//     const storedAccessLevel = localStorage.getItem("AccessLevel");
//     setAccessLevel(storedAccessLevel || "employee");
//   }
//   const handleLogout = () => {
//     // Set the isLoggedIn state to false
//     setIsLoggedIn(false);
//     // Remove the loggedIn flag from sessionStorage
//     sessionStorage.removeItem("loggedIn");
//     // Remove the access level from localStorage
//     localStorage.removeItem("AccessLevel");
//   }
//   const handleLoginFormSubmit = (email, password) => {
//     signInwithGoogle(email, password)
//       .then((user) => {
//         // Pass in the user information to handleLogin
            

        
//       //   async function createOrUpdateEmployee(employeeData) {
//       //     try {
//       //         const response = await fetch("http://localhost:5000/employees", {
//       //             method: "POST",
//       //             headers: {
//       //                 "Content-Type": "application/json"
//       //             },
//       //             body: JSON.stringify(employeeData)
//       //         });
//       //   async function createOrUpdateEmployee(employeeData) {
//       //     try {
//       //         const response = await fetch("http://localhost:5000/employees", {
//       //             method: "POST",
//       //             headers: {
//       //                 "Content-Type": "application/json"
//       //             },
//       //             body: JSON.stringify(employeeData)
//       //         });
      
//       //         const data = await response.json();
//       //         console.log("Response:", data);
//       //         const data = await response.json();
//       //         console.log("Response:", data);
      
//       //         if (response.ok) {
//       //             alert(data.message); // Show success message
//       //         } else {
//       //             alert("Error: " + data.error); // Show error message
//       //         }
//       //     } catch (error) {
//       //         console.error("Error:", error);
//       //     }
//       // }
//       //         if (response.ok) {
//       //             alert(data.message); // Show success message
//       //         } else {
//       //             alert("Error: " + data.error); // Show error message
//       //         }
//       //     } catch (error) {
//       //         console.error("Error:", error);
//       //     }
//       // }

//       //   createOrUpdateEmployee(user)
//       //   createOrUpdateEmployee(user)


//         console.log(user)
//         handleLogin({
//           role: "employee",
//           photo: user.photoURL,
//           name: user.displayName,
//           email: user.email
//         }, user);
//       })
//       .catch((error) => {
//         alert(error.message);
//       });
//   };
//         console.log(user)
//         handleLogin({
//           role: "employee",
//           photo: user.photoURL,
//           name: user.displayName,
//           email: user.email
//         }, user);
//       })
//       .catch((error) => {
//         alert(error.message);
//       });
//   };


//   if (isLoading) {
//     return <div>Loading...</div>; // Show a loading indicator while determining access
//   }
//   if (isLoading) {
//     return <div>Loading...</div>; // Show a loading indicator while determining access
//   }

  
//   if (!isLoggedIn) {
//     return <Login handleLoginFormSubmit={handleLoginFormSubmit} />;
//   } else {
//     return (
//       <ColorModeContext.Provider value={colorMode}>
//         <ThemeProvider theme={theme}>
//           <CssBaseline />
//           <div className="app"   style={{ display: 'flex', minHeight: '100vh' }} >
//             <Sidebar isSidebar={isSidebar}   style={{
//       width: '250px', 
//       backgroundColor: '#f4f4f4', 
//       padding: '20px', 
//       position: 'relative', 
//       height: 'auto' // Let the height adjust dynamically based on content
//     }} />
//             <main className="content"      style={{
//       flex: 1, 
//       padding: '20px', 
//       overflowY: 'auto' // Allows scrolling if content overflows
//     }} >
//               <Topbar setIsSidebar={setIsSidebar} handleLogout={handleLogout} />
//               <Routes>
//                 <Route path="/Dashboard" element={<Dashboard />} />
//   if (!isLoggedIn) {
//     return <Login handleLoginFormSubmit={handleLoginFormSubmit} />;
//   } else {
//     return (
//       <ColorModeContext.Provider value={colorMode}>
//         <ThemeProvider theme={theme}>
//           <CssBaseline />
//           <div className="app"   style={{ display: 'flex', minHeight: '100vh' }} >
//             <Sidebar isSidebar={isSidebar}   style={{
//       width: '250px', 
//       backgroundColor: '#f4f4f4', 
//       padding: '20px', 
//       position: 'relative', 
//       height: 'auto' // Let the height adjust dynamically based on content
//     }} />
//             <main className="content"      style={{
//       flex: 1, 
//       padding: '20px', 
//       overflowY: 'auto' // Allows scrolling if content overflows
//     }} >
//               <Topbar setIsSidebar={setIsSidebar} handleLogout={handleLogout} />
//               <Routes>
//                 <Route path="/Dashboard" element={<Dashboard />} />


//                 <Route path="/team" element={<Team />} />
//                 <Route path="/team" element={<Team />} />


//                 <Route path="/calendar" element={<Calendar />} />
//                 <Route path="/calendar" element={<Calendar />} />


//                 <Route path="/LeaveSection" element={<LeaveSection />} />
//                 <Route path="/ApplyLeave" element={<ApplyLeave />} />
//                 <Route path="/AppliedLeaves" element={<AppliedLeaves />} />
//                 <Route path="/PublicHolidays" element={<PublicHolidays />} />
//                 <Route path="/past90days" element={<Past90DaysData />} />
//                 <Route path="/currentmonth" element={<CurrentMonthData />} />
//                 <Route path="/transsitionhistory" element={<TranssitionHistory />} />
//                 <Route path="/Attendence" element={<CheckInOutRecords></CheckInOutRecords>}/>
//                 <Route path="/employee-payroll" element={<EmployeePayroll></EmployeePayroll>}/>
//                 <Route path="/LeaveSection" element={<LeaveSection />} />
//                 <Route path="/ApplyLeave" element={<ApplyLeave />} />
//                 <Route path="/AppliedLeaves" element={<AppliedLeaves />} />
//                 <Route path="/PublicHolidays" element={<PublicHolidays />} />
//                 <Route path="/past90days" element={<Past90DaysData />} />
//                 <Route path="/currentmonth" element={<CurrentMonthData />} />
//                 <Route path="/transsitionhistory" element={<TranssitionHistory />} />
//                 <Route path="/Attendence" element={<CheckInOutRecords></CheckInOutRecords>}/>
//                 <Route path="/employee-payroll" element={<EmployeePayroll></EmployeePayroll>}/>
                
                
//                 {acess === "admin" ? (
//                   <Route path="/ApproveLeave" element={<ApproveLeave />} />
//                 ) : (
//                   <Route path="/ApproveLeave" element={
//                     <Box m="30px">
//                       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//                     </Box>} />
//                 )}
//                 {acess === "admin" ? (
//                   <Route path="/ApproveLeave" element={<ApproveLeave />} />
//                 ) : (
//                   <Route path="/ApproveLeave" element={
//                     <Box m="30px">
//                       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//                     </Box>} />
//                 )}

// <Route path="/leave-details/:applicationno" element={<LeaveDetails />} />
// <Route path="/leave-details/:applicationno" element={<LeaveDetails />} />

// <Route path="/Add_Employee" element={
//   acess === "admin" ? (
//     <AddEmployee />
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />
// <Route path="/job_application" element={
//   acess === "admin" ? (
//     <Jobapplication/>
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />
// <Route path="/Add_Employee" element={
//   acess === "admin" ? (
//     <AddEmployee />
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />
// <Route path="/job_application" element={
//   acess === "admin" ? (
//     <Jobapplication/>
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />

// <Route
//   path="/job-details/:id"
//   element={
//     acess === "admin" ? (
//       <JobDetails />
//     ) : (
//       <Box m="30px">
//         <Header title="You do not have access to this page" subtitle="Access Denied!" />
//       </Box>
//     )
//   }
// />
// <Route path="/Add_Job" element={
//   acess === "admin" ? (
//     <ColorModeContext.Provider value={colorMode}>
//     <ThemeProvider theme={theme}>
//       <CssBaseline /> {/* resets default browser styles */}
//       <AddJob />
//     </ThemeProvider>
//   </ColorModeContext.Provider>
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />
// <Route
//   path="/job-details/:id"
//   element={
//     acess === "admin" ? (
//       <JobDetails />
//     ) : (
//       <Box m="30px">
//         <Header title="You do not have access to this page" subtitle="Access Denied!" />
//       </Box>
//     )
//   }
// />
// <Route path="/Add_Job" element={
//   acess === "admin" ? (
//     <ColorModeContext.Provider value={colorMode}>
//     <ThemeProvider theme={theme}>
//       <CssBaseline /> {/* resets default browser styles */}
//       <AddJob />
//     </ThemeProvider>
//   </ColorModeContext.Provider>
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />

 



// <Route path="/Add_Address_Details" element={
//   acess === "admin" ? (
// <AppAddressDetails></AppAddressDetails>
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />
// <Route path="/Add_Address_Details" element={
//   acess === "admin" ? (
// <AppAddressDetails></AppAddressDetails>
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />


// <Route path="/Add_Bank_Details" element={
//   acess === "admin" ? (
// <AppBankDetails></AppBankDetails>
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />
// <Route path="/Add_Bank_Details" element={
//   acess === "admin" ? (
// <AppBankDetails></AppBankDetails>
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />



// <Route path="/Add_document" element={
//   acess === "admin" ? (
//     <AppDocument />
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />
// <Route path="/Add_document" element={
//   acess === "admin" ? (
//     <AppDocument />
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />




// <Route path="/Add_qualification" element={
//   acess === "admin" ? (
//     <AppQualification />
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />
// <Route path="/Add_qualification" element={
//   acess === "admin" ? (
//     <AppQualification />
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />
 




//  <Route path="/add_payroll" element={
//   acess === "admin" ? (
//       <PayrollTable></PayrollTable>
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />
//  <Route path="/add_payroll" element={
//   acess === "admin" ? (
//       <PayrollTable></PayrollTable>
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />




//  <Route path="/Add_workexperience" element={
//   acess === "admin" ? (
//     <AppEmployeeWorkExperience />
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />
//  <Route path="/Add_workexperience" element={
//   acess === "admin" ? (
//     <AppEmployeeWorkExperience />
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />







// <Route path="/Add_emergency_contact" element={
//   acess === "admin" ? (
//     <AppEmergencyContact/>
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />
// <Route path="/Add_emergency_contact" element={
//   acess === "admin" ? (
//     <AppEmergencyContact/>
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />
 




//  <Route path="/Add_deduct_leave" element={
//   acess === "admin" ? (
//     <AppAutoComplete/>
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />
//  <Route path="/Add_deduct_leave" element={
//   acess === "admin" ? (
//     <AppAutoComplete/>
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />
 


 

//  <Route path="/Add_holiday" element={
//   acess === "admin" ? (
//     <Holiday/>
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />
//  <Route path="/Add_holiday" element={
//   acess === "admin" ? (
//     <Holiday/>
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />




// <Route path="/Add_check_in_out" element={
//   acess === "admin" ? (
//     <CheckInOut/>
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />
// <Route path="/Add_check_in_out" element={
//   acess === "admin" ? (
//     <CheckInOut/>
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />



// <Route path="/dashboard-hrm" element={
//   acess === "admin" ? (
//     <Analytics/>
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />
// <Route path="/dashboard-hrm" element={
//   acess === "admin" ? (
//     <Analytics/>
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />




// <Route path="/upload_csv_check_in_out" element={
//   acess === "admin" ? (
//     <CsvUploader></CsvUploader>
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />
// <Route path="/upload_csv_check_in_out" element={
//   acess === "admin" ? (
//     <CsvUploader></CsvUploader>
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />




// <Route path="/material/EmpList" element={
//   acess === "admin" ? (
//     <AppEmpList></AppEmpList>
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />
// <Route path="/material/EmpList" element={
//   acess === "admin" ? (
//     <AppEmpList></AppEmpList>
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />







// <Route path="/employee/:id" element={
//   acess === "admin" ? (
//         <EmployeeDetails></EmployeeDetails>
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />
// <Route path="/employee/:id" element={
//   acess === "admin" ? (
//         <EmployeeDetails></EmployeeDetails>
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />



// <Route path="/edit-employee/:employeeId" element={
//   acess === "admin" ? (
// <Route path="/edit-employee/:employeeId" element={
//   acess === "admin" ? (
        
//     <EditEmployee></EditEmployee>
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />
//     <EditEmployee></EditEmployee>
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />





// <Route path="/edit-employee/:employeeId/edit-personal" element={
//   acess === "admin" ? (
// <Route path="/edit-employee/:employeeId/edit-personal" element={
//   acess === "admin" ? (
        
//       <EditPersonal></EditPersonal>
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />
//       <EditPersonal></EditPersonal>
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />




// <Route path="/edit-employee/:employeeId/edit-address" element={
//   acess === "admin" ? (
// <Route path="/edit-employee/:employeeId/edit-address" element={
//   acess === "admin" ? (
        
//     <EditAddress></EditAddress>
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />
//     <EditAddress></EditAddress>
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />



// <Route path="/edit-employee/:employee_id/edit-document" element={
//   acess === "admin" ? (
// <Route path="/edit-employee/:employee_id/edit-document" element={
//   acess === "admin" ? (
        
//     <EditDocument></EditDocument>
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />
//     <EditDocument></EditDocument>
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />




// <Route path="/edit-employee/:employee_id/edit-work" element={
//   acess === "admin" ? (
// <Route path="/edit-employee/:employee_id/edit-work" element={
//   acess === "admin" ? (
        
//        <EditWork></EditWork>
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />
//        <EditWork></EditWork>
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />





// <Route path="/edit-employee/:employee_id/edit-qualification" element={
//   acess === "admin" ? (
// <Route path="/edit-employee/:employee_id/edit-qualification" element={
//   acess === "admin" ? (
        
//       <EditQualification></EditQualification>
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />
//       <EditQualification></EditQualification>
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />
 



//  <Route path="/edit-employee/:employee_id/edit-emergency" element={
//   acess === "admin" ? (
//  <Route path="/edit-employee/:employee_id/edit-emergency" element={
//   acess === "admin" ? (
      
//     <EditEmergency></EditEmergency>
//     <EditEmergency></EditEmergency>
     
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />




// <Route path="/ctc" element={
//   acess === "admin" ? (
//     <CTCForm></CTCForm>
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />
// <Route path="/ctc" element={
//   acess === "admin" ? (
//     <CTCForm></CTCForm>
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />


// <Route path="/employee/:id/payslip" element={
//   acess === "admin" ? (
//     <Payslip ></Payslip>
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />
// <Route path="/employee/:id/payslip" element={
//   acess === "admin" ? (
//     <Payslip ></Payslip>
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />


// {/* <Route path="/payslipZip" element={
//   acess === "admin" ? (
//     <PayslipZip ></PayslipZip>
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } /> */}
// {/* <Route path="/payslipZip" element={
//   acess === "admin" ? (
//     <PayslipZip ></PayslipZip>
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } /> */}

// <Route path="/payrollpage" element={
//   acess === "admin" ? (
//     <AddExistingEmployeePayroll></AddExistingEmployeePayroll>
//   ) : (
//     <Box m="30px">
//       <Header title="You do not have access to this page" subtitle="Access Denied!" />
//     </Box>
//   )
// } />

 

                
//                 {/* <Route path="/Add_personal_details" element={<AppPersonalDetails></AppPersonalDetails>}></Route> */}


//                 <Route path="*" element={<Navigate to="/Dashboard" />} />
//               </Routes>
//             </main>
//           </div>
//         </ThemeProvider>
//       </ColorModeContext.Provider>
//     );
//   }
// }

// export default App;




//our previous UI  route that we have to change that causing an issuee that access denied 








import { useState, useEffect } from "react";
import { useLocation } from 'react-router-dom';
import { Routes, Route, Navigate } from "react-router-dom";
import Topbar from "./scenes/global/Topbar";
import Sidebar from "./scenes/global/Sidebar";
import Dashboard from "./scenes/dashboard";
import Team from "./scenes/team";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import Calendar from "./scenes/calendar/calendar";
import LeaveSection from "./scenes/Leaves";
import ApplyLeave from "./scenes/ApplyLeave";
import AppliedLeaves from "./scenes/AppliedLeaves";
import PublicHolidays from "./scenes/PublicHolidays";
import Login from "./login";
import { signInwithGoogle } from "./firebase";
import ApproveLeave from "./scenes/ApproveLeave";
import { Box } from '@mui/material';
import Header from "./components/Header";
import Past90DaysData from "./scenes/dashboard/past90days";
import TranssitionHistory from "./scenes/dashboard/transsitionhistory";
import CurrentMonthData from "./scenes/dashboard/currentmonth";
import CheckInOutRecords from "./scenes/Attendence/CheckInCheckOut";
import AppPersonalDetails from "./hrm/app/views/material-kit/HRAdmin/AppPersonalDetails";
import AddEmployee from "./hrm/app/views/material-kit/HRAdmin/AddEmployee";
import AddJob from "./hrm/app/views/material-kit/HRAdmin/AddJob";
import DevHeader from "./hrm/app/components/Header";
import { AuthProvider } from "./hrm/app/components/AuthContext";
import Footer from "./hrm/app/components/Footer";
import AppAddressDetails from "./hrm/app/views/material-kit/HRAddress/AppAddressDetails";
import AppBankDetails from "./hrm/app/views/material-kit/HRAddress/AppBankDetails";
import AppDocument from "./hrm/app/views/material-kit/HRDocument/AppDocument";
import AppQualification from "./hrm/app/views/material-kit/HRQualification/AppQualificationDetails";
import AppEmployeeWorkExperience from "./hrm/app/views/material-kit/HRWorkExperience/AppWorkExperience";
import AppEmergencyContact from "./hrm/app/views/material-kit/HREmergencyContact/AppEmergencyContact";
import AppAutoComplete from "./hrm/app/views/material-kit/auto-complete/AppAutoComplete";
import Holiday from "./hrm/app/views/material-kit/holidays/Holidays";
import CheckInOut from "./hrm/app/views/material-kit/holidays/CheckInOut";
import CsvUploader from "./hrm/app/views/material-kit/CSV/CsvUploader";
import Analytics from "./hrm/app/views/dashboard/Analytics";
import { jwtDecode } from "jwt-decode";
import AppEmpList from "./hrm/app/views/material-kit/HRAdmin/AppEmpList";
import EmployeeDetails from "./hrm/app/views/material-kit/HRAdmin/EmployeeDetails";
import EditEmployee from "./hrm/app/views/material-kit/HRAdmin/EditEmployee";
import EditAddress from "./hrm/app/views/material-kit/HRAddress/EditAddress";
import EditDocument from "./hrm/app/views/material-kit/HRDocument/EditDocument";
import EditPersonal from "./hrm/app/views/material-kit/HRAdmin/EditPersonal";
import EditWork from "./hrm/app/views/material-kit/HRWorkExperience/EditWork";
import EditQualification from "./hrm/app/views/material-kit/HRQualification/EditQualification";
import EditEmergency from "./hrm/app/views/material-kit/HREmergencyContact/EditEmergency";
import PayrollTable from "./scenes/payroll/PayrollTable";
import EmployeePayroll from "./scenes/payroll/EmployeePayroll";
import CTCForm from "./scenes/payroll/CTCForm";
import PayrollPage from "./scenes/payroll/PayrollPage";
import Payslip from "./scenes/payroll/Payslip";
import Payrollslippdf from "./scenes/payroll/Payrollslippdf";
import Paypdf from "./scenes/payroll/Payrollslippdf";
import EmployeesOnLeaveTable from "./hrm/app/views/dashboard/shared/EmployeeOnLeave";
import Jobapplication from "./hrm/app/views/material-kit/jobapplication";
import Config from "./hrm/app/views/material-kit/Config";
import JobDetails from "./hrm/app/views/material-kit/jobapplication/jobdetails";
import LeaveDetails from "./scenes/ApproveLeave/Leavedetails";
import AddExistingEmployeePayroll from "./scenes/payroll/AddExistingEmployeePayroll";
import { initializeTokenRefresher, stopTokenRefresher }from "./token-manager/tokenRefresherInit";
import ShortlistForm from "./hrm/app/views/material-kit/jobapplication/ShortlistForm";
import SelectedForm from "./hrm/app/views/material-kit/jobapplication/SelectedForm";
import OnboardingForm from "./hrm/app/views/material-kit/jobapplication/OnboardingForm";
import initializeFetch from './hrm/app/utils/initializeFetch';
import EmployeePayslip from "./scenes/payroll/EmployeePayslip";
// initializeFetch();
function App() {
  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [accessLevel, setAccessLevel] = useState(null); // Changed from acess to accessLevel
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
initializeTokenRefresher();

  useEffect(() => {
    const checkAuthStatus = async () => {
      const loggedIn = sessionStorage.getItem("loggedIn");
      if (loggedIn === "true") {
        setIsLoggedIn(true);
        await determineAccessLevel();
      } else {
        setIsLoading(false);
      }
    };

    checkAuthStatus();
  }, []);

  const determineAccessLevel = async () => {
    try {
      const token = sessionStorage.getItem("authToken");
      if (!token) {
        throw new Error("No token found");
      }

      const decoded = jwtDecode(token);
     const level = String(decoded.isAdmin).toLowerCase() === "true" ? "admin" : "employee";
      localStorage.setItem("level",level);
      setAccessLevel(level);
      setIsLoading(false);
    } catch (error) {
      console.error("Error determining access level:", error);
      setIsLoading(false);
    }
  };

  const handleLogin = async (userInfo, useralldetails) => {
    localStorage.setItem("userInfo", JSON.stringify(userInfo));
    localStorage.setItem("useralldetails", useralldetails);
    setIsLoggedIn(true);
    sessionStorage.setItem("loggedIn", "true");
    await determineAccessLevel();
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    setAccessLevel(null);
    sessionStorage.removeItem("loggedIn");
    localStorage.removeItem("AccessLevel");
    localStorage.removeItem("userInfo");
    localStorage.removeItem("useralldetails");

    stopTokenRefresher();
    
  };

const handleLoginFormSubmit = async () => {
  try {
    const userData = await signInwithGoogle();
    handleLogin({
      role: userData.role,
      photo: userData.photo,
      name: userData.name,
      email: userData.email
    }, userData.user);
  } catch (error) {
    alert(error.message);
  }
};
  const isPublicFormRoute =
    location.pathname.startsWith("/shortlist-form/") ||
    location.pathname.startsWith("/selected-form/") ||
    location.pathname.startsWith("/onboarding-form/");
  if (isLoading) {
    return <div>Loading...</div>;
  }

    if (!isLoggedIn) {
      return (
        <>
          {!isPublicFormRoute && (
            <Login handleLoginFormSubmit={handleLoginFormSubmit} />
          )}

          {isPublicFormRoute && (
            <AuthProvider>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  minHeight: "100vh",    
                  width: "100%",
                  boxSizing: "border-box",
                }}
              >
                <DevHeader />

                <Box
                  sx={{
                    flex: 1,                 
                    display: "flex",
                    flexDirection: "column",
                    px: { xs: 3, md: 8 },
                  }}
                >
                  <Routes>
                    <Route path="/shortlist-form/:id" element={<ShortlistForm />} />
                    <Route path="/selected-form/:id" element={<SelectedForm />} />
                    <Route path="/onboarding-form/:id" element={<OnboardingForm />} />
                  </Routes>
                </Box>

                <Footer /> 
              </Box>
            </AuthProvider>
          )}

        </>
      );
    }

  const AdminRoute = ({ element, ...rest }) => {
    return accessLevel === "admin" ? (
      element
    ) : (
      <Box m="30px">
        <Header title="You do not have access to this page" subtitle="Access Denied!" />
      </Box>
    );
  };

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className="app" style={{ display: 'flex', minHeight: '100vh' }}>
          <Sidebar isSidebar={isSidebar} accessLevel={accessLevel} style={{
            width: '250px',
            backgroundColor: '#f4f4f4',
            padding: '20px',
            position: 'relative',
            height: 'auto'
          }} />
          <main className="content" style={{
            flex: 1,
            padding: '20px',
            overflowY: 'auto'
          }}>
            <Topbar setIsSidebar={setIsSidebar} handleLogout={handleLogout} />
            <Routes>
              {/* Public routes */}
              <Route path="/Dashboard" element={<Dashboard />} />
              <Route path="/team" element={<Team />} />
              <Route path="/calendar" element={<Calendar />} />
              <Route path="/LeaveSection" element={<LeaveSection />} />
              <Route path="/ApplyLeave" element={<ApplyLeave />} />
              <Route path="/AppliedLeaves" element={<AppliedLeaves />} />
              <Route path="/PublicHolidays" element={<PublicHolidays />} />
              <Route path="/past90days" element={<Past90DaysData />} />
              <Route path="/currentmonth" element={<CurrentMonthData />} />
              <Route path="/transsitionhistory" element={<TranssitionHistory />} />
              <Route path="/Attendence" element={<CheckInOutRecords />} />
              <Route path="/employee-payroll" element={<EmployeePayroll />} />
              <Route path="/employee/:id/payslip" element={<Payslip />} />
              <Route path="/employee/:id/employeepayslip" element={<EmployeePayslip />} />
              {/* Admin routes */}
              <Route path="/ApproveLeave" element={<AdminRoute element={<ApproveLeave />} />} />
             

              <Route path="/Add_Employee" element={<AdminRoute element={<AddEmployee />} />} />
              <Route path="/edit-employee/:employeeId" element={<AdminRoute element={<AddEmployee />} />} />
              
              <Route path="/job_application" element={<AdminRoute element={<Jobapplication />} />} />
        
              <Route path="/job-details/:id" element={<AdminRoute element={<JobDetails />} />} />
               
              <Route path="/leave-details/:applicationno" element={<AdminRoute element={<LeaveDetails />} />} />
               
              <Route path="/config" element={<Config />} />
              <Route path="/Add_Job" element={<AddJob></AddJob>}></Route>

              {/* <Route path="/Add_personal_details" element={<AdminRoute element={<AppPersonalDetails />} />} />
              <Route path="/Add_Address_Details" element={<AdminRoute element={<AppAddressDetails />} />} />
              <Route path="/Add_Bank_Details" element={<AdminRoute element={<AppBankDetails />} />} />
              <Route path="/Add_document" element={<AdminRoute element={<AppDocument />} />} />
              <Route path="/Add_qualification" element={<AdminRoute element={<AppQualification />} />} />
              <Route path="/Add_workexperience" element={<AdminRoute element={<AppEmployeeWorkExperience />} />} />
              <Route path="/Add_emergency_contact" element={<AdminRoute element={<AppEmergencyContact />} />} /> */}
              <Route path="/add_payroll" element={<AdminRoute element={<PayrollTable />} />} />
              <Route path="/Add_deduct_leave" element={<AdminRoute element={<AppAutoComplete />} />} />
              <Route path="/Add_holiday" element={<AdminRoute element={<Holiday />} />} />
              <Route path="/Add_check_in_out" element={<AdminRoute element={<CheckInOut />} />} />
              <Route path="/dashboard-hrm" element={<AdminRoute element={<Analytics />} />} />
              {/* <Route path="/upload_csv_check_in_out" element={<AdminRoute element={<CsvUploader />} />} /> */}
              <Route path="/material/EmpList" element={<AdminRoute element={<AppEmpList />} />} />
              <Route path="/employee/:id" element={<AdminRoute element={<EmployeeDetails />} />} />
              {/* <Route path="/edit-employee/:employeeId" element={<AdminRoute element={<EditEmployee />} />} /> */}
              {/* <Route path="/edit-employee/:employeeId/edit-personal" element={<AdminRoute element={<EditPersonal />} />} />
              <Route path="/edit-employee/:employeeId/edit-address" element={<AdminRoute element={<EditAddress />} />} />
              <Route path="/edit-employee/:employee_id/edit-document" element={<AdminRoute element={<EditDocument />} />} />
              <Route path="/edit-employee/:employee_id/edit-work" element={<AdminRoute element={<EditWork />} />} />
              <Route path="/edit-employee/:employee_id/edit-qualification" element={<AdminRoute element={<EditQualification />} />} />
              <Route path="/edit-employee/:employee_id/edit-emergency" element={<AdminRoute element={<EditEmergency />} />} /> */}
              <Route path="/ctc" element={<AdminRoute element={<CTCForm />} />} />
              <Route path="/payrollpage" element={<AdminRoute element={<AddExistingEmployeePayroll />} />} />
              <Route path="/pdfextract" element={<AdminRoute element={<Paypdf />} />} />
              {/* <Route path="/App_add_user" element={<AdminRoute element={<EmployeeManagementTabs />} />} /> */}

              {/* Fallback route */}
              <Route path="*" element={<Navigate to="/Dashboard" />} />
            </Routes>
          </main>
        </div>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;








